export const messages = {
  en: {
    jobManage: {
      queryCondition: 'Query Conditions',
      enterTaskId: 'Please enter task ID',
      enterTaskName: 'Please enter task name',
      selectTemplateName: 'Please select template name',
      query: 'Query',
      reset: 'Reset',
      timedTask: 'Scheduled Tasks',
      add: 'Add',
      taskName: 'Task Name',
      runTime: 'Run Time',
      templateName: 'Template Name',
      createTime: 'Create Time',
      status: 'Status',
      operation: 'Operation',
      running: 'Running',
      stopped: 'Stopped',
      start: 'Start',
      stop: 'Stop',
      edit: 'Edit',
      delete: 'Delete',
      startSuccess: 'Start successfully',
      stopSuccess: 'Stop successfully'
    },
    addJob: {
      addTask: 'Add Task',
      taskName: 'Task Name',
      enterTaskName: 'Required, please enter task name',
      selectTemplate: 'Select Template',
      selectTemplatePlaceholder: 'Required, please select template',
      timing: 'Timing',
      enterTiming: 'Optional, please enter timing',
      cancel: 'Cancel',
      save: 'Save',
      addSuccess: 'Add successfully',
      taskNameRequired: 'Task name cannot be empty',
      templateRequired: 'Template cannot be empty'
    },
    editJob: {
      editTask: 'Edit Task',
      taskName: 'Task Name',
      enterTaskName: 'Required, please enter task name',
      selectTemplate: 'Select Template',
      selectTemplatePlaceholder: 'Required, please select template',
      timing: 'Timing',
      enterTiming: 'Optional, please enter timing',
      cancel: 'Cancel',
      save: 'Save',
      editSuccess: 'Edit successfully',
      taskNameRequired: 'Task name cannot be empty',
      templateRequired: 'Template cannot be empty'
    },
    deleteJob: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteTask: 'Confirm to delete the task?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    jobManage: {
      queryCondition: '查询条件',
      enterTaskId: '请输入任务ID',
      enterTaskName: '请输入任务名称',
      selectTemplateName: '请选择模板名称',
      query: '查询',
      reset: '重置',
      timedTask: '定时任务',
      add: '添加',
      taskName: '任务名称',
      runTime: '运行时间',
      templateName: '模板名称',
      createTime: '创建时间',
      status: '状态',
      operation: '操作',
      running: '运行中',
      stopped: '已停止',
      start: '启动',
      stop: '停止',
      edit: '修改',
      delete: '删除',
      startSuccess: '启动成功',
      stopSuccess: '停止成功'
    },
    addJob: {
      addTask: '添加任务',
      taskName: '任务名称',
      enterTaskName: '必填，请填写任务名称',
      selectTemplate: '选择模板',
      selectTemplatePlaceholder: '必填，请选择模板',
      timing: '定时时间',
      enterTiming: '选填，请填写定时时间',
      cancel: '取消',
      save: '保存',
      addSuccess: '添加成功',
      taskNameRequired: '任务名称不能为空',
      templateRequired: '模板不能为空'
    },
    editJob: {
      editTask: '修改任务',
      taskName: '任务名称',
      enterTaskName: '必填，请填写任务名称',
      selectTemplate: '选择模板',
      selectTemplatePlaceholder: '必填，请选择模板',
      timing: '定时时间',
      enterTiming: '选填，请填写定时时间',
      cancel: '取消',
      save: '保存',
      editSuccess: '修改成功',
      taskNameRequired: '任务名称不能为空',
      templateRequired: '模板不能为空'
    },
    deleteJob: {
      confirmOperation: '请确认您的操作',
      confirmDeleteTask: '确定删除任务？',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功'
    }
  }
}